import { render, staticRenderFns } from "./AddToFavourites.vue?vue&type=template&id=1d1262ee"
import script from "./AddToFavourites.vue?vue&type=script&lang=js"
export * from "./AddToFavourites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports